import { render } from "./BreadCrumbs.vue?vue&type=template&id=46dfc550"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__